<!-- DEPRECATED -->
<p-panel header="{{ 'GROUP'  | translate }}" styleClass="p-panel-whitebg mb-3">
	<div class="grid p-0 px-2 mb-5 lg:mb-3 mt-0 md:p-1">
		<div class="col-12">
			<p-table dataKey="Id" [value]="mtmaRules" sortField="Name" [sortOrder]="1" responsiveLayout="stack"
				(onLazyLoad)="loadRule($event)" [paginator]="true" [totalRecords]="totalRecords" [loading]="ruleLoading"
				[rows]="rulePageSize" [showCurrentPageReport]="true"
				currentPageReportTemplate="{{ 'TABLE_REPORT' | translate }}" [autoLayout]="true">
				<ng-template pTemplate="caption">
					<div class="grid">
						<div [class]="actionLayout('left')">
							<!-- <button pButton pRipple icon="pi cm-plus"
								label="{{ 'ADD_RULE' | translate }}" (click)="addRule()" [disabled]="ruleResultLength>=ruleMaxMemorySize || isActiveTask"
								class="p-button-primary text-normal border-transparent font-medium py-1">
							</button> -->
							<p-button id="addMtmaRule" label="{{ 'ADD_RULE' | translate }}" (click)="addRule()"
								[disabled]="ruleResultLength>=ruleMaxMemorySize || isActiveTask || deprecated" icon="pi cm-plus"
								[rounded]="false" [text]="true" severity="primary" styleClass="font-bold border-primary">
							</p-button>
						</div>
						<div [class]="actionLayout('center')">
							<div class="flex flex-column justify-content-center gap-2">
								<span class="flex align-items-center justify-content-center">
									<i class="pi cm-memory-storage mr-1"></i>
									{{'MEMORY_USAGE' | translate }}: {{ruleMemorySize}} / {{ruleMaxMemorySize}}
								</span>
								<p-progressBar [value]="getValueMemory()">
									<ng-template pTemplate="content" let-value>
										<span *ngIf="getValueMemory() >= 10">{{getValueMemory()}} %</span>
									</ng-template>
								</p-progressBar>
							</div>
						</div>
						<div [class]="actionLayout('right')">
							<!--<span class="p-input-icon-left" [class]="dynamicInputSearchWidth()">
								<i class="pi cm-search"></i>
								<input [formControl]="searchFilter" pInputText type="text"
									id="mtma-control-access-rules-input-search"
									placeholder="{{ 'SEARCH' | translate }}"
									[ngClass]="dynamicInputSearchWidth()"
									maxlength="60"/>
							</span>-->
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header" class="flex align-items-center justify-content-center">
					<tr>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'NAME' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'TIMESLOT' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center">{{ 'SPECIALPERIOD' | translate }}</div>
						</th>
						<th>
							<div class="flex align-items-center justify-content-center"></div>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-rule>
					<tr>
						<td>
							<span class="p-column-title font-semibold">{{ 'NAME' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{ rule.Name }}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'TIMESLOT' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{getNumTimeslot(rule)}}</div>
						</td>
						<td>
							<span class="p-column-title font-semibold">{{ 'SPECIALPERIOD' | translate }}</span>
							<div class="flex align-items-center justify-content-center">{{getNumSpecialPeriod(rule)}}</div>
						</td>
						<td>
							<span class="p-column-title"></span>
							<div class="flex flex-row justify-content-center align-items-center gap-1">
								<p-button pTooltip="{{ 'EDIT' | translate}}" [disabled]="rule.Fixed || isActiveTask || deprecated"
									tooltipPosition="bottom" icon="pi cm-pencil" size="large" (click)="editRule(rule)"
									[rounded]="false" [text]="true" severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'MANAGE_ACCESS' | translate}}" [disabled]="rule.Fixed || isActiveTask || deprecated"
									tooltipPosition="bottom" icon="pi cm-user" size="large" (click)="openRuleAccess(rule)"
									[rounded]="false" [text]="true" severity="secondary">
								</p-button>
								<p-button pTooltip="{{ 'DELETE' | translate}}" [disabled]="rule.Fixed || isActiveTask"
									tooltipPosition="bottom" icon="pi cm-trash" size="large" (click)="deleteRule(rule)"
									[rounded]="false" [text]="true" severity="danger">
								</p-button>
							</div>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">{{ 'TABLE_NO_ELEMENT' | translate }}</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
</p-panel>
<p-confirmDialog #confDialog>
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>